/*
  Remember, we have access to our Vue instance not using
  an arrow function in our actions file. This allows us
  to create a scoped reference to our firebaseService - $fb
  That was assigned to the Vue instance earlier in our serviceConnection
  boot file.
*/

import { firestoreAction } from 'vuexfire'
//import User from '../../models/User'
import { docRef } from '../../_services/firebase/db.js'
import { collectionRef } from '../../_services/firebase/db.js'
import router from '../../router/index'
//import { Notify } from 'quasar'
//import classroom from '../classroom/index.js'
import firebase from 'firebase/compat/app'

export const latestLogin = async function($root,submissionData){
  ////console.log(payload.worldname)
  ////console.log(payload)
console.log(submissionData.id)
console.log(firebase.firestore.Timestamp.now())

  var user = await collectionRef('users')
  .where('id', '==', submissionData.id) 
  //.where()
  .get()
  .then((querySnapshot) => {
    //console.log(querySnapshot)
    var docarray = []
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
        //console.log(doc.id, " => ", doc.data());
        var docplus = doc.data()
        docplus.refid= doc.id
      docarray.push(docplus)
    })
    return docarray
  })
  .catch((error) => {
    console.log('Error getting document:', error)
  })



    docRef("users",user[0].refid).update({
      'latestLogin': firebase.firestore.Timestamp.now()
    })
  
  //commit('setAwardState', 
 // answers[0]
 // )*/
}
export const addLastLoginToUsersCollection = function (state, userRef) {
  console.log(state)
  console.log(userRef)
  
  
  //return userRef.update(user)
}

/**
 * @param {Object} $root - Place holder argument(Vuex store) to allow data to be passed
 *  as second argument.
 * @param data.email - User's email
 * @param data.password - User's password
 * @returns {function} - Firebase services function:
 * src/services/firebase/email.js > createUserWithEmail
 */
/*
export const createNewUser = async function ($root, data) {
  const $fb = this.$fb
  console.log('Data')
  console.log(data)
  const { email, password } = data
  console.log(email)
  console.log(password)
  const fbAuthResponse = await $fb.createUserWithEmail(email, password)
  console.log(fbAuthResponse.user.uid)
  const id = fbAuthResponse.user.uid
  const userRef = docRef('users', id)

  return addUserToUsersCollection(data, userRef)
}

export const createAnswer = async function ($root, data) {
  const $fb = this.$fb
  console.log('Data')
  console.log(data)
  const { email, password } = data
  console.log(email)
  console.log(password)
  const fbAuthResponse = await $fb.createUserWithEmail(email, password)
  console.log(fbAuthResponse.user.uid)
  const id = fbAuthResponse.user.uid
  const userRef = docRef('users', id)

  return addUserToUsersCollection(data, userRef)
}
*/
/**
 * @param {Object} $root - Place holder argument(Vuex store) to allow data to be passed
 *  as second argument.
 * @param data.email - User's email
 * @param data.password - User's password
 * @returns {function} - Firebase services function:
 * src/services/firebase/email.js > loginWithEmail
 */
export const loginUser = async function ($root, data) {
  console.log("login")

  const $fb = this.$fb
  const { email, password } = data
  //var successLoginEmail=
  // console.log(successLoginEmail)
  // console.log(successLoginEmail.i)
  // if (successLoginEmail){
  //   console.log('succeeded')
  // const userRef = docRef('users', id)

  //this.commit('user/setCurrentUserData', {role:"organize"}, { root: true })

  // }
  console.log(data)
  //docRef('users', data.id).update(data)
  var userstuff= $fb.loginWithEmail(email, password)
  
  //const userRef = docRef('users', id)
  //addLastLoginToUsersCollection()
  //docRef('users', data.id).update(data)

  return userstuff
}

/**
 * @returns {function} - Firebase services function:
 * src/services/firebase/email.js > logoutUser
 */
export const logoutUser = async function ({ commit }) {
  try {
    await firestoreAction(({ unbindFirestoreRef }) => {
      unbindFirestoreRef('currentUser')
    })
    commit('user/setCurrentUserData', null, { root: true })
    await this.$fb.logoutUser()
    //commit('common/setDrawerOpen', false, { root: true })
    // commit('user/setNullUserOnLogout', this)
  } catch (err) {

    console.log(err)
    //Notify.create({
    //  type: 'webapp_error',
    //  message: `An error as occured [logoutUser]: ${err}`
   // })
  }
}

export function routeUserToAuth() {
  router.push({
    path: '/login'
  })
}
